import { Row, TitleCell } from "@zapier/shared";

import {
  CountCell,
  CheckAppConnectionCell,
  AppTagCell,
  AccessCell,
} from "./cells";

import {
  getAppDetailsUrl,
  getZapsByAppUrl,
  getConnectionsByAppUrl,
  PLACEHOLDER_APP_ICON,
  AssetTypes,
  stripVersionFromImplementationName,
} from "@zapier/utils";
interface Props {
  app: any;
  allowSelection?: boolean;
}

const AppRow = ({ allowSelection, app }: Props) => {
  const appVersion = app?.selectedApi?.split("@")[1] ?? "";

  // If the app has a slug, link to the app details page
  // If app has no slug, it means it is a private app, link to app details page with /private
  const appHref = app?.slug
    ? getAppDetailsUrl(app?.slug)
    : getAppDetailsUrl(`private/${app.selectedApi}`);

  const connectionsHref = app?.selectedApi
    ? getConnectionsByAppUrl(app.selectedApi)
    : undefined;

  const zapsHref = getZapsByAppUrl(app?.selectedApi, app?.slug) || undefined;

  return (
    <Row
      allowsSelection={allowSelection}
      assetType={AssetTypes.App}
      id={String(app?.id)}
      showOptions={false}
    >
      <TitleCell
        assetType={AssetTypes.App}
        id={app.id}
        serviceIconSrc={app?.images?.url32X32 || PLACEHOLDER_APP_ICON}
        subtitle={appVersion}
        title={stripVersionFromImplementationName(app?.title)}
        url={appHref}
      />
      <AppTagCell badges={app?.implementationMeta?.badges} />
      <CheckAppConnectionCell isStale={!!app?.hasStaleAuth} />
      <CountCell count={app?.stats?.authCount || 0} href={connectionsHref} />
      <CountCell
        showZapIcon
        count={app?.stats?.zapCount || 0}
        href={zapsHref}
      />
      <AccessCell
        members={app?.stats?.members}
        memberCount={app?.stats?.memberCount}
      />
    </Row>
  );
};

const AppRowContainer = (props: Props) => {
  return <AppRow {...props} />;
};

export default AppRowContainer;
